import CacheCleaner from "./CacheCleaner"
import Common from '@/assets/js/common.js'

export default class HorseActesTypeActiveCleaner extends CacheCleaner {

	async onMutation(actestype_ids) {
		Common.storageDelete('all_actes_groupes')
	}
}